// Stok Yönetimi sayfası ve pencereleri. Excel dosyaları ve stok tipi adları Türkçe kalır.
const stock = {
  page: {
    title: 'Stok Yönetimi',
    subtitle: 'Sarf malzemeleri ve demirbaşlar: stok, atama, hareketler ve kargo takibi tek ekranda.',
  },
  modules: {
    label: 'Stok yönetimi modülleri',
    stocks: 'Stoklar',
    cargo: 'Kargo Takip',
  },
  categories: {
    label: 'Kategori',
    all: 'Tüm Stoklar',
    allShort: 'Tümü',
    sarf: 'Sarf Malzemesi',
    sarfShort: 'Sarf',
    demirbas: 'Demirbaş',
    unknown: 'Belirsiz',
    sarfHint: 'Sarf malzemeleri: tüketilen, son kullanma tarihli ürünler (tıbbi malzeme, temizlik vb.).',
    demirbasHint: 'Demirbaş: uzun ömürlü, amortisman hesaplanan varlıklar (ekipman, mobilya vb.).',
  },
  status: {
    aktif: 'Aktif',
    inaktif: 'İnaktif',
  },
  ownership: {
    owned: 'Firma Malı (Bizim)',
    rented: 'Kiralık',
    customer: 'Müşteriye Ait',
    loaned: 'Emanet / Ödünç',
    other: 'Diğer',
  },
  common: {
    cancel: 'İptal',
  },
  actions: {
    report: 'Kullanım Raporu',
    reportHint: 'Kime ne kadar verildi, ne kadar kullanıldı, ne kadar kaldı',
    assigned: 'Atanan Stoklar',
    assignedHint: 'Çalışanlara atanmış stokların özeti',
    types: 'Stok Tipleri',
    typesHint: 'Stok tipi ekle veya kullanılmayanı sil',
    excel: 'Excel',
    excelAll: 'Tüm stoklar',
    excelAllHint: 'Filtrelenen stokların ayrıntılı listesi, stok durumuna göre renkli.',
    excelMovements: 'Stok hareketleri',
    excelMovementsHint: 'Filtrelenen stokların tüm atama ve vizit hareketleri.',
    add: 'Yeni Stok',
  },
  stats: {
    total: 'Toplam Stok',
    totalShort: 'Toplam',
    active: 'Aktif Stok',
    activeShort: 'Aktif',
    inactive: 'İnaktif Stok',
    inactiveShort: 'İnaktif',
    low: 'Azalan Stok',
    lowShort: 'Azalan',
    share: 'Bu kategorinin %{{percent}}’i',
  },
  toolbar: {
    search: 'Ürün adı, bilgi veya stok tipi ile ara…',
    searchShort: 'Stok ara…',
    typeFilter: 'Stok tipine göre filtrele',
    allTypes: 'Tüm tipler ({{count}})',
    clearType: 'Stok tipi filtresini temizle',
    expiring: 'SKT yaklaşanlar',
    expiringHint: 'Son kullanma tarihi bir ay içinde olanları listele',
    low: 'Düşük stok',
    lowHint: 'Kalan miktarı min miktara inmiş ürünleri listele',
  },
  table: {
    listLabel: 'Stok listesi',
    empty: 'Filtrelere uygun ürün bulunamadı',
    rangeOf: '/ {{total}} stok',
    ofTotal: 'toplam {{total}} stok içinden',
    lowHint: 'Kalan miktar min miktara indi',
  },
  card: {
    remaining: 'Kalan',
    min: 'min {{min}}',
  },
  columns: {
    name: 'Ürün Adı',
    category: 'Kategori',
    info: 'Bilgi',
    customer: 'Müşteri',
    project: 'Proje',
    ownership: 'Sahiplik',
    warehouse: 'Depo',
    status: 'Durum',
    rate: 'Döviz Kuru',
    currency: 'Döviz Tipi',
    purchasePrice: 'Giriş Fiyatı',
    remaining: 'Kalan',
    minQuantity: 'Min Miktar',
    profitRate: 'Kar Oranı (%)',
    startDate: 'Kullanma Başlama Tarihi',
    quantity: 'Miktar',
    expiryDate: 'Son Kullanma Tarihi',
    stockType: 'Stok Tipi',
    depreciation: 'Yıpranma Payı',
    salePrice: 'Çıkış Fiyatı',
  },
  panel: {
    label: 'Seçili stok',
    heading: 'Stok',
    low: 'Azalan stok',
    edit: 'Düzenle',
    assign: 'Stok Ata',
    history: 'Stok Hareketleri',
    toSarf: 'Sarfa Çevir',
    toDemirbas: 'Demirbaşa Çevir',
    categoryHint: 'Stoğun kategorisini değiştirir',
    activate: 'Aktif yap',
    deactivate: 'İnaktif yap',
    statusHint: 'Stoğun durumunu değiştirir',
  },
  form: {
    titleAdd: 'Yeni Stok Ekle',
    subtitleAdd: 'Stok bilgilerini girerek yeni ürün ekleyin',
    titleEdit: 'Stok Düzenle',
    subtitleEdit: 'Stok bilgilerini güncelleyin',
    required: 'Zorunlu',
    optional: 'Seçin (opsiyonel)',
    select: 'Seçin',
    add: 'Stok Ekle',
    update: 'Güncelle',
    sections: {
      category: 'Kategori Seçimi',
      basic: 'Temel Bilgiler',
      stock: 'Stok & Depo',
      pricing: 'Fiyatlandırma',
      dates: 'Tarih Bilgileri',
      fixture: 'Demirbaş Bilgileri',
    },
    categoryDesc: {
      sarf: 'Tüketim malzemeleri, son kullanma tarihli ürünler',
      demirbas: 'Sabit kıymetler, ekipman ve uzun ömürlü varlıklar',
    },
    name: 'Ürün Adı',
    namePlaceholder: 'Ürün adını girin',
    typePlaceholder: 'Tip seçin',
    noTypes: 'Henüz stok tipi eklenmemiş. Lütfen önce "Stok Tipleri" bölümünden stok tipi ekleyin.',
    statusPlaceholder: 'Durum seçin',
    info: 'Bilgi / Açıklama',
    infoPlaceholder: 'Ek bilgi girin',
    remaining: 'Kalan Miktar',
    minHint: 'Stok bu değerin altına düşünce uyarı verilir',
    warehouse: 'Depo Lokasyonu',
    warehousePlaceholder: 'Depo adı veya lokasyon',
    currencies: {
      TRY: 'Türk Lirası',
      USD: 'Amerikan Doları',
      EUR: 'Euro',
    },
    profit: 'Kar Oranı',
    ownership: 'Sahiplik Türü',
    ownershipHint: 'Demirbaş bizim mi, kiralık mı, müşteriye mi ait?',
    depreciation: 'Yıpranma Payı (%)',
    depreciationPlaceholder: 'Yıllık amortisman oranı',
    depreciationHint: 'Demirbaş için yıllık değer kaybı oranını girin',
    scope: {
      customer: 'Müşteri',
      customerFixture: 'Müşteri / Firma',
      customerPlaceholder: 'Müşteri seçin (opsiyonel)',
      ownCompany: '{{name}} (Kendi firmamız)',
      project: 'Proje',
      projectPlaceholder: 'Proje seçin (opsiyonel)',
      projectsUnavailable: 'Proje listesi yüklenemedi.',
      ownCompanyHint: 'Demirbaş firmamıza ait; kullanıldığı projeyi seçebilirsiniz.',
      noMatchingProject: 'Bu müşteriye bağlı proje bulunamadı; tüm projeler listeleniyor.',
    },
  },
  assign: {
    title: 'Stok Ata',
    total: 'Toplam Miktar',
    remaining: 'Kalan Miktar',
    employee: 'Çalışan',
    employeePlaceholder: 'Bir çalışan seçin…',
    quantity: 'Miktar',
    quantityPlaceholder: 'Atanacak miktar',
    max: 'En fazla: {{max}}',
    note: 'Not',
    notePlaceholder: 'Opsiyonel not ekleyin…',
    submit: 'Ata',
  },
  history: {
    title: 'Stok Hareketleri',
    excel: 'Excel İndir',
    empty: 'Bu stok için henüz hareket kaydı bulunmuyor.',
    columns: {
      date: 'Tarih',
      person: 'Çalışan / Ziyaret',
      quantity: 'Miktar',
      type: 'Tip',
      note: 'Not',
      action: 'İşlem',
    },
    types: {
      assignment: 'Çalışan Ataması',
      visit_usage: 'Ziyaret Kullanımı',
      visit_return: 'Ziyaret İadesi',
      adjustment: 'Düzeltme',
      return: 'İade',
      general: 'Genel',
    },
    visit: 'Ziyaret: {{patient}}',
    noPatient: 'Hasta ID yok',
    unknownEmployee: 'Bilinmeyen çalışan',
    undo: 'Geri Al',
    undoHint: 'Atamayı geri al: miktar stoğa döner',
    visitMovement: 'Ziyaret hareketi',
    noAction: 'İşlem yok',
    confirmUndo: {
      title: 'Atamayı geri al',
      message: '{{quantity}} adet {{stock}} stoğu geri alınacak ve hareket kaydı silinecek. Onaylıyor musunuz?',
    },
  },
  types: {
    title: 'Stok Tipleri',
    subtitle: 'Yeni stok tipi ekleyin; hiç ürünü olmayan tipi silebilirsiniz.',
    name: 'Stok Tipi Adı',
    placeholder: 'Örn: Elektronik, Gıda, Temizlik…',
    add: 'Ekle',
    existing: 'Mevcut stok tipleri ({{count}})',
    inUseHint: 'Bu tipe ait ürün sayısı; ürünü olan tip silinemez',
    delete: '"{{name}}" tipini sil',
    help: 'Sayı, o tipe ait ürün sayısıdır. Ürünü olmayan tipler × ile silinebilir.',
    confirmDelete: {
      title: 'Stok tipini sil',
      message: '"{{name}}" stok tipini silmek istediğinize emin misiniz?',
      confirm: 'Sil',
    },
  },
  assigned: {
    title: 'Atanan Stoklar',
    subtitle: 'Çalışanlara atanmış stok ürünlerinin özeti',
    loading: 'Atama verileri yükleniyor…',
    summary: {
      label: 'Atama özeti',
      total: 'Toplam Atama',
      employees: 'Çalışan',
      none: 'Atama Yok',
      products: 'Farklı Ürün',
      quantity: 'Toplam Miktar',
    },
    searchEmployee: 'Çalışan adı veya stok adıyla ara…',
    searchStock: 'Stok adı veya çalışan adıyla ara…',
    views: {
      label: 'Görünüm',
      employee: 'Çalışana Göre',
      stock: 'Stoğa Göre',
    },
    filters: {
      label: 'Çalışanları süz',
      all: 'Tümü',
      assigned: 'Ataması olanlar',
      unassigned: 'Atama yapılmayanlar',
    },
    empty: {
      title: 'Kayıt bulunamadı',
      search: 'Arama kriterlerine uygun kayıt yok.',
      allAssigned: 'Tüm çalışanlara en az bir stok atanmış.',
      noneYet: 'Henüz hiçbir çalışana stok atanmamış.',
      stockTitle: 'Atama bulunamadı',
      stockNone: 'Henüz hiçbir stok atanmamış.',
    },
    employeeMeta: '{{count}} atama • {{quantity}} adet toplam',
    none: 'Atama yok',
    noItems: 'Bu çalışana henüz stok atanmamış',
    stockMeta: '{{count}} çalışan • {{quantity}} adet dağıtıldı',
    units: '{{quantity}} adet',
  },
  report: {
    title: 'Stok Kullanım Raporu',
    subtitle: 'Kime ne kadar verildi, ne kadar kullanıldı, ne kadar kaldı',
    summary: {
      label: 'Rapor özeti',
      assigned: 'Dağıtılan',
      used: 'Kullanılan',
      onHand: 'Sahada',
      remaining: 'Depoda kalan',
    },
    tabs: {
      label: 'Rapor türü',
      employee: 'Çalışanlar',
      customer: 'Müşteriler',
      project: 'Projeler',
      stock: 'Malzemeler',
    },
    columns: {
      employee: {
        employeeName: 'Çalışan',
        assigned: 'Verilen',
        used: 'Kullanılan',
        onHand: 'Elinde',
        usageRate: 'Kullanım',
        visitCount: 'Vizit',
        perVisit: 'Vizit başına',
      },
      customer: {
        label: 'Müşteri',
        assigned: 'Gönderilen',
        used: 'Kullanılan',
        onHand: 'Sahada',
        remaining: 'Depoda kalan',
        usageRate: 'Kullanım',
        stockCount: 'Malzeme',
      },
      project: {
        label: 'Proje',
        assigned: 'Gönderilen',
        used: 'Kullanılan',
        onHand: 'Sahada',
        remaining: 'Depoda kalan',
        usageRate: 'Kullanım',
        stockCount: 'Malzeme',
      },
      stock: {
        stockName: 'Malzeme',
        customerName: 'Müşteri',
        projectName: 'Proje',
        assigned: 'Dağıtılan',
        used: 'Kullanılan',
        remaining: 'Depoda kalan',
        employeeCount: 'Kişi',
      },
    },
    onlyConsumables: 'Sadece sarf',
    onlyConsumablesHint: 'Yalnızca sarf malzemelerini raporla',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    search: 'Ara…',
    excel: 'Excel',
    careful: '{{name}} en tutumlu kullanıyor — vizit başına {{amount}} adet',
    heavy: '{{name}} en çok tüketiyor — vizit başına {{amount}} adet',
    loading: 'Rapor hazırlanıyor…',
    empty: 'Seçilen aralıkta kayıt bulunmuyor.',
    records_one: '{{count}} kayıt',
    records_other: '{{count}} kayıt',
    hint: 'Vizit başına ortalama düştükçe kullanım daha tutumlu demektir.',
    critical: 'Kritik',
    usedRate: '{{percent}} kullanıldı',
  },
  toast: {
    added: 'Stok başarıyla eklendi!',
    addError: 'Stok eklenirken hata oluştu: {{message}}',
    selectToEdit: 'Lütfen düzenlemek için bir stok seçin',
    updated: 'Stok başarıyla güncellendi!',
    updateError: 'Stok güncellenirken hata oluştu: {{message}}',
    selectToToggleStatus: 'Lütfen durum değiştirmek için bir stok seçin',
    statusUpdated: 'Stok durumu {{status}} olarak güncellendi!',
    statusError: 'Durum değiştirilirken hata oluştu: {{message}}',
    selectToToggleCategory: 'Lütfen kategori değiştirmek için bir stok seçin',
    categorySarf: 'Stok "Sarf Malzemesi" olarak güncellendi!',
    categoryDemirbas: 'Stok "Demirbaş" olarak güncellendi!',
    categoryError: 'Kategori değiştirilirken hata oluştu: {{message}}',
    employeesError: 'Çalışanlar yüklenirken hata oluştu',
    selectToAssign: 'Lütfen stok hareketi için bir stok seçin',
    selectEmployee: 'Lütfen bir çalışan seçin',
    invalidQuantity: 'Lütfen geçerli bir miktar girin',
    insufficient: 'Yetersiz stok! Kalan miktar: {{remaining}}',
    assigned: '{{quantity}} adet {{stock}} {{employee}} adlı çalışana atandı',
    assignError: 'Stok hareketi kaydedilirken hata oluştu: {{message}}',
    historyError: 'Stok geçmişi yüklenirken hata oluştu',
    noMovementsToExport: 'Dışa aktarılacak stok hareketi bulunamadı',
    historyExported: 'Stok hareketleri Excel dosyası başarıyla indirildi!',
    excelError: 'Excel dosyası oluşturulurken bir hata oluştu',
    noFilteredStocks: 'Seçili filtrelere uygun stok bulunamadı',
    loadingMovements: 'Stok hareketleri yükleniyor...',
    noMovementsForFiltered: 'Filtrelenmiş stoklar için hareket bulunamadı',
    movementsExported: '{{count}} adet stok hareketi Excel dosyasına aktarıldı!',
    stocksExported: '{{count}} adet stok bilgisi Excel dosyasına aktarıldı!',
    selectToHistory: 'Lütfen geçmiş görüntülemek için bir stok seçin',
    undone: '{{quantity}} adet stok başarıyla geri alındı',
    undoError: 'Stok geri alınırken hata oluştu: {{message}}',
    duplicatesCleaned: '{{count}} tekrarlayan stok tipi temizlendi',
    typesError: 'Stok tipleri yüklenirken hata oluştu',
    defaultTypesAdded: 'Varsayılan stok tipleri eklendi!',
    defaultTypesError: 'Varsayılan stok tipleri eklenirken hata oluştu',
    typeNameRequired: 'Lütfen bir stok tipi adı girin',
    typeExists: 'Bu stok tipi zaten mevcut',
    typeAdded: 'Stok tipi başarıyla eklendi!',
    typeAddError: 'Stok tipi eklenirken hata oluştu: {{message}}',
    assignedError: 'Atanan stoklar yüklenirken hata oluştu',
    typeInUse: 'Bu stok tipine ait ürünler var, silinemez!',
    typeDeleted: 'Stok tipi başarıyla silindi!',
    typeDeleteError: 'Stok tipi silinirken hata oluştu: {{message}}',
    loadError: 'Stok verileri yüklenirken hata oluştu',
    lowStock: '⚠️ {{count}} ürünün stok miktarı belirlenen minimum değerin altına düştü!',
    excelDownloaded: 'Excel dosyası başarıyla indirildi ({{count}} kayıt)',
    excelDownloadError: 'Excel dosyası indirilirken hata oluştu',
  },
};

export default stock;
